export default "__VITE_ASSET__C2lnbfu5__"